var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLog = function SvgLog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.994C1 2.894 1.893 2 2.995 2h14.01C18.107 2 19 2.895 19 3.994v12.012c0 1.1-.893 1.994-1.995 1.994H2.995C1.893 18 1 17.105 1 16.006V3.994zM4 5v1.5h12V5H4zm0 3v1.5h12V8H4zm0 3v1.5h7V11H4z",
    fillRule: "evenodd"
  })));
};
export default SvgLog;